/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { ComparisonMode } from 'enums'
import { SocialWebTimelineComparisonWidget } from 'schemas/SocialWebTimelineComparisonWidgetSchema'
import { MAX_MATRIXED_ITEM_COUNT } from '../../../utils'
import { getComparisonModeLangKey } from '../../utils'

const TagsMatrixedItemCountGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebTimelineComparisonWidget>(widgetId)
  const { t } = useTranslation()

  const matrixedItemCount = widgetSetting.metricNames?.length || 0

  if (matrixedItemCount === 0) {
    return (
      <ErrorMessage>
        {t('noSelectPivots', {
          comparisonModeOption: t(getComparisonModeLangKey(ComparisonMode.TAGS))
        })}
      </ErrorMessage>
    )
  }

  if (matrixedItemCount > MAX_MATRIXED_ITEM_COUNT) {
    return (
      <ErrorMessage>{t('tooManyMatrixedItems', { num: MAX_MATRIXED_ITEM_COUNT })}</ErrorMessage>
    )
  }

  return children
}

export default TagsMatrixedItemCountGuard
